export function compare(a, b, operator) {
    switch (operator) {
        case "<=":
            return a <= b
        case "<":
            return a < b
        case ">=":
            return a >= b
        case ">":
            return a > b
        default:
            throw new Error("Invalid operator")
    }
}